import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthApiService } from './modules/auth/services/auth-api/auth-api.service';
import { ExitIntentService } from './core/services/infrastructure/exit-intent/exit-intent.service';
import { PaywallService } from './modules/paywall/services/paywall.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false,
})
export class AppComponent implements OnInit {
    constructor(
        private readonly authService: AuthApiService,
        private readonly router: Router,
        private readonly exitIntentService: ExitIntentService,
        private readonly paywallService: PaywallService
    ) {}

    ngOnInit(): void {
        this.exitIntentService.watch();
        this.paywallService.watchTrialEnd();

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            const refresh = this.router.parseUrl(this.router.url).queryParams['refresh'];
            if (refresh !== 'true') {
                return;
            }

            this.authService.removeUser();
            this.authService.refresh().subscribe();

            const queryParams = { ...this.router.parseUrl(this.router.url).queryParams };
            delete queryParams['refresh'];

            this.router.navigate([], {
                queryParams,
                replaceUrl: true,
                queryParamsHandling: '',
            });
        });
    }
}
